import React from 'react';
import { Row, Col } from 'antd';
import styled, { keyframes } from 'styled-components';

var shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

var SkeletonContainer = styled.div`
  padding: 0;
`;

var SkeletonBase = styled.div`
  background: linear-gradient(
    90deg,
    #f0f0f0 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite linear;
  border-radius: 4px;
`;

var SkeletonTab = styled(SkeletonBase)`
  height: 40px;
  border-radius: 4px 4px 0 0;
`;

var SkeletonCard = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
`;

var SkeletonCardHeader = styled.div`
  background: #fafafa;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #d9d9d9;
`;

var SkeletonCardBody = styled.div`
  padding: 16px;
  background: #fff;
`;

var SkeletonIcon = styled(SkeletonBase)`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  margin-right: 8px;
`;

var SkeletonTitle = styled(SkeletonBase)`
  height: 18px;
  border-radius: 4px;
`;

var SkeletonProgress = styled(SkeletonBase)`
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;

var SkeletonLabel = styled(SkeletonBase)`
  height: 14px;
  margin-bottom: 8px;
`;

var SkeletonInput = styled(SkeletonBase)`
  height: 32px;
  margin-bottom: 16px;
`;

var SkeletonFormItem = function(props) {
  return (
    <div>
      <SkeletonLabel style={{ width: props.labelWidth || 80 }} />
      <SkeletonInput />
    </div>
  );
};

var SkeletonSection = function(props) {
  return (
    <SkeletonCard>
      <SkeletonCardHeader>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <SkeletonIcon />
          <SkeletonTitle style={{ width: props.titleWidth || 150 }} />
        </div>
        <SkeletonProgress />
      </SkeletonCardHeader>
      {props.expanded !== false && (
        <SkeletonCardBody>
          {props.children}
        </SkeletonCardBody>
      )}
    </SkeletonCard>
  );
};

export var DrawerSkeleton = function() {
  return (
    <SkeletonContainer>
      {/* Tabs skeleton */}
      <div style={{ display: 'flex', marginBottom: 16, borderBottom: '1px solid #e8e8e8' }}>
        <SkeletonTab style={{ width: 60, marginRight: 4 }} />
        <SkeletonTab style={{ width: 80, marginRight: 4 }} />
        <SkeletonTab style={{ width: 90, marginRight: 4 }} />
        <SkeletonTab style={{ width: 100 }} />
      </div>

      {/* Informações de Contato */}
      <SkeletonSection titleWidth={180}>
        <Row gutter={16}>
          <Col span={16}>
            <SkeletonFormItem labelWidth={50} />
          </Col>
          <Col span={8}>
            <SkeletonFormItem labelWidth={90} />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <SkeletonFormItem labelWidth={45} />
          </Col>
          <Col span={12}>
            <SkeletonFormItem labelWidth={65} />
          </Col>
        </Row>
      </SkeletonSection>

      {/* Origem e Qualificação - collapsed */}
      <SkeletonSection titleWidth={160} expanded={false} />

      {/* Datas e Status - collapsed */}
      <SkeletonSection titleWidth={120} expanded={false} />

      {/* Follow Up e Reuniões - collapsed */}
      <SkeletonCard>
        <SkeletonCardHeader>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SkeletonIcon />
            <SkeletonTitle style={{ width: 160 }} />
            <div style={{ marginLeft: 8, width: 24, height: 18, borderRadius: 10, background: '#e0e0e0' }} />
          </div>
          <SkeletonBase style={{ width: 80, height: 24, borderRadius: 4 }} />
        </SkeletonCardHeader>
      </SkeletonCard>
    </SkeletonContainer>
  );
};
